// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"624":"clere","738":"course-manager"}[chunkId] || chunkId) + "." + {"354":"024f89c5","368":"5c83349e","436":"d71d18f0","624":"f049e046","668":"f583838e","738":"2198544f","838":"3787910e"}[chunkId] + ".js";
};